<template>
    <address-list scope="people"></address-list>
</template>

<script>
import AddressList from '@/components/address/List.vue';

export default {
    name: 'PeopleAddressesList',

    components: {
        AddressList,
    },
};
</script>
